import { Button } from "@mui/material";
import styled from "styled-components";

export const ButtonContainer = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1.5rem;
  width: 100%;
`;

export const ConfirmButton = styled(Button)`
  && {
    background-color: #FE2F67;
    color: white;
    padding: 0.625rem 1.5rem;
    border-radius: 0.5rem;
    text-transform: none;
    font-size: 1rem;
    flex: 1;
    min-height: 2.5rem;
    
    &:hover {
      background-color: #e62a5d;
    }

    &:disabled {
      background-color: #FCA5A5;
      color: white;
    }
  }
`;

export const RejectButton = styled(Button)`
  && {
    background-color: #F3F4F6;
    color: #1F2937;
    padding: 0.625rem 1.5rem;
    border-radius: 0.5rem;
    text-transform: none;
    font-size: 1rem;
    flex: 1;
    min-height: 2.5rem;
    
    &:hover {
      background-color: #E5E7EB;
    }

    &:disabled {
      background-color: #E5E7EB;
      color: #9CA3AF;
    }
  }
`;

export const StatusContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 1rem 0;
`;

export const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

export const ErrorMessage = styled.div`
  color: #DC2626;
  background-color: #FEE2E2;
  border: 1px solid #FCA5A5;
  border-radius: 0.5rem;
  padding: 0.75rem 1rem;
  margin: 1rem 0;
  font-size: 0.9rem;
  text-align: center;
`; 